import { render } from "./EditGoalModal.vue?vue&type=template&id=5dfe1ecc&scoped=true"
import script from "./EditGoalModal.vue?vue&type=script&lang=js"
export * from "./EditGoalModal.vue?vue&type=script&lang=js"

import "./EditGoalModal.vue?vue&type=style&index=0&id=5dfe1ecc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfe1ecc"]])

export default __exports__